import { ActionButton, ActionButtonInverted } from 'components/button/button.styled'
import { ButtonContainer, SeatContainer, SeatLabel } from 'components/ticket/ticket.style'
import { SeatSellingModes } from 'types/Event'
import { Seat } from 'types/Location'
import { getGeneralSeatLabel, getSeatLabelForSeatId } from 'utils/seatLabel'

interface SeatTicketControlsProps {
    currentEvent: any
    selectedSeats: string[]
    activeLoadingKey: string | null
    setActiveLoadingKey: (key: string | null) => void
    handlePrintTicket: (seatId: string) => Promise<void>
    handleDownloadTicket: (seatId: string) => Promise<void>
    areAllTicketsSold?: boolean
}

export const SeatTicketControls = ({
    currentEvent,
    selectedSeats,
    activeLoadingKey,
    setActiveLoadingKey,
    handlePrintTicket,
    handleDownloadTicket,
    areAllTicketsSold,
}: SeatTicketControlsProps) => {
    const isAnyLoading = activeLoadingKey !== null

    const isButtonDisabled = (key: string) => isAnyLoading && activeLoadingKey !== key

    const showButtons = areAllTicketsSold === undefined || areAllTicketsSold

    return (
        <ul>
            {selectedSeats.map((seatId) => {
                const seat =
                    currentEvent.location.auditorium.seats.find((s: Seat) => s.seat_id === seatId) ||
                    currentEvent.location.auditorium.gallery?.seats.find((s: Seat) => s.seat_id === seatId)
                if (!seat) return <li key={seatId}>Invalid seat: {seatId}</li>

                let seatLabel: string

                if (currentEvent.seat_selling_mode === SeatSellingModes.SeatBased) {
                    seatLabel = getSeatLabelForSeatId(currentEvent, seatId) ?? 'Ismeretlen hely'
                } else {
                    seatLabel = getGeneralSeatLabel(seatId, selectedSeats)
                }

                const downloadKey = `download-${seatId}`
                const printKey = `print-${seatId}`

                return (
                    <SeatContainer key={seatId}>
                        <SeatLabel>{seatLabel}</SeatLabel>
                        <ButtonContainer>
                            {showButtons && (
                                <>
                                    <ActionButton
                                        label={activeLoadingKey === downloadKey ? 'Letöltés...' : 'Letöltés'}
                                        onClick={async () => {
                                            setActiveLoadingKey(downloadKey)
                                            await handleDownloadTicket(seatId)
                                            setActiveLoadingKey(null)
                                        }}
                                        disabled={isButtonDisabled(downloadKey)}
                                    />
                                    <ActionButtonInverted
                                        label={activeLoadingKey === printKey ? 'Nyomtatás...' : 'Nyomtatás'}
                                        onClick={async () => {
                                            setActiveLoadingKey(printKey)
                                            await handlePrintTicket(seatId)
                                            setActiveLoadingKey(null)
                                        }}
                                        disabled={isButtonDisabled(printKey)}
                                    />
                                </>
                            )}
                            {!showButtons && <span>A fizetés folyamatban</span>}
                        </ButtonContainer>
                    </SeatContainer>
                )
            })}
        </ul>
    )
}
